export default "__VITE_ASSET__6e87e6d0__"